import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import Attachments from "../../Pages/Submitter/AttachmentsAndDeclaration/Attachments";
import FindOutAward from "../../Pages/Submitter/AttachmentsAndDeclaration/FindOutAward";
import Pledge from "../../Pages/Submitter/AttachmentsAndDeclaration/Pledge";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import { UpdateAC_NT_AS_AwardSource } from "../../Redux/Reducers/Submitter/AwardSource";
import Swal from "sweetalert2";
import { UpdateAC_NT_CM_Commitment } from "../../Redux/Reducers/Submitter/Commitment";
import { ValidationAttachments } from "../../Redux/Reducers/Submitter/AttachmentsAnswer";
import { useEffect, useState } from "react";
import PopupAHSF from "../../Components/PopupAHSF";
import ValidationView from "../../Components/ValidationView";
import { SubmitApplication } from "../../Redux/Reducers/Shared/ApplicationInformation";
import Survey from "../../Pages/Shared/Survey";
import ReactDOM from "react-dom/client";
import { AddSurvey } from "../../Redux/Reducers/Shared/Survey";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AttachmentsAndDeclaration = () => {
  const AttachmentsAnswerList = useSelector(
    (state) => state.AttachmentsAnswer.ValidationAttachments
  );
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);
  const navigate = useNavigate();
  const JsonDataa = useSelector((state) => state.FetchDataJson.JsonData);
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      AwardSource: state.AwardSource.AwardSource,
      Commitment: state.Commitment.Commitment,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const notify = (message) =>
    toast.success(message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      className: "notify-bar",
    });
  const SaveDataPage = async () => {
    if (isSubmitting) return; // Prevent double clicks
    setIsSubmitting(true);

    try {
      // Save award source + commitment first
      await dispatch(UpdateAC_NT_AS_AwardSource({ ...state.AwardSource }));
      await dispatch(UpdateAC_NT_CM_Commitment({ ...state.Commitment }));

      // Validate attachments
      const validationResult = await dispatch(
        ValidationAttachments({
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          ),
          Lang: lang,
        })
      );

      if (validationResult.payload?.length > 0) {
        // Show popup if validation fails
        setPopupComponentValidationViewStatus(true);
      } else if (validationResult.payload?.length == 0) {
        // If validation passes, submit application
        Swal.fire({
          title:
            lang == "ar"
              ? "  هل انت متأكد من تقديم الطلب ؟"
              : "Are you sure about submitting the application?",
          icon: "info",
          iconHtml: lang == "ar" ? "؟" : "?",
          confirmButtonText: lang == "ar" ? "تقديم" : "Confirmed",
          cancelButtonText: lang == "ar" ? "إلغاء" : "Cancel",
          showCancelButton: true,
          showCloseButton: true,
          customClass: {
            confirmButton: "btn-success",
            cancelButton: "btn-danger",
          },
        }).then(async (res) => {
          console.log(res, "reddds");

          if (res.isConfirmed == true) {
            const updated = await dispatch(
              SubmitApplication({
                applicationInformationId: localStorage.getItem(
                  "ApplicationInformationId"
                ),
                applicationStatusId: "521bf595-b593-4551-a2b6-8fb3719314de",
              })
            );

            if (updated.payload) {
              notify(
                lang === "ar" ? "تم تقديم طلبك بنجاح" : "Submitted Successfully"
              );
              showSurveyPopup(lang, rating, handleConfirm);
            }
          }
        });

        //
      }
    } catch (error) {
      console.error("Error in SaveDataPage:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closePopupComponentValidationViewStatus = () => {
    setPopupComponentValidationViewStatus((prev) => !prev);
  };
  const [rating, setRating] = useState(null);
  const [reviewText, setReviewText] = useState("");
  function showSurveyPopup(lang, initialRating = null, onConfirmed) {
    Swal.fire({
      title:
        lang == "ar"
          ? JsonDataa?.ratingPopup.nameAR
          : JsonDataa?.ratingPopup.nameEN,
      // icon: "question",
      // iconHtml: `★`,
      text: "ماهو تقييمك لتجربة استخدام نظام التقدم",
      html: `
     
   
      <div id="survey-container" style="margin-top:10px;"></div>`,
      confirmButtonText: lang === "ar" ? "تقييم" : "Confirm",
      cancelButtonText: lang === "ar" ? "إلغاء" : "Cancel",
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        confirmButton: "surveyBtn",
        icon: "surveyIcon",
        title: "titlePop",
      },
      didOpen: () => {
        const container = document.getElementById("survey-container");

        const SurveyWrapper = () => {
          const [rating, setRating] = useState(initialRating);
          const [comment, setComment] = useState("");

          useEffect(() => {
            container._getRating = () => rating;
            container._getComment = () => comment.trim();
          }, [rating, comment]);

          return (
            <Survey
              value={rating}
              onChange={setRating}
              onCommentChange={setComment}
              lang={lang}
              commentRequiredThreshold={3}
            />
          );
        };

        const root = ReactDOM.createRoot(container);
        root.render(<SurveyWrapper />);
        container._reactRoot = root;
      },

      preConfirm: () => {
        const container = document.getElementById("survey-container");
        const rating = container._getRating ? container._getRating() : null;
        const comment = container._getComment ? container._getComment() : "";

        if (rating === null) {
          Swal.showValidationMessage(
            lang === "ar" ? "الرجاء اختيار تقييم" : "Please choose a rating"
          );
          return false;
        }

        if (rating <= 3 && comment.length === 0) {
          Swal.showValidationMessage(
            lang === "ar"
              ? "الرجاء كتابة ملاحظتك "
              : "Please explain your rating"
          );
          return false;
        }

        return { rating, comment };
      },

      willClose: () => {
        const container = document.getElementById("survey-container");
        if (container && container._reactRoot) {
          container._reactRoot.unmount();
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { rating, comment } = result.value || {};
        if (typeof onConfirmed === "function") onConfirmed(rating, comment);
      } else {
        window.location.replace("/ResearchersAward/mainpage");
      }
    });
  }
  const handleConfirm = async (rating, comment) => {
    console.log(comment, "Rating:", rating);

    const add = await dispatch(
      AddSurvey({
        surveysResult: rating,
        description: comment,
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        ),
      })
    );
    if (add.payload) {
      window.location.replace("/ResearchersAward/mainpage");
    }
  };

  const disabled = state.ActiveRound;
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Attachments"
        titleNameAR="المرفقات"
        lang={lang}
        child={[<Attachments applicationGuid={""} disabled={disabled} />]}
      />
      <SharedDiv
        showTitle={true}
        titleNameEN="How did you find out about the award?"
        titleNameAR="كيف عرفت عن الجائزة"
        lang={lang}
        child={[<FindOutAward applicationGuid={""} disabled={disabled} />]}
      />
      <SharedDiv
        showTitle={true}
        titleNameEN="Pledge"
        titleNameAR="التعهد"
        lang={lang}
        child={[<Pledge disabled={disabled} />]}
      />
      {!disabled ? (
        <div className="containerButtonMAin">
          {/* Previous Button */}
          <ButtonAHSF
            type={"submitter"}
            show={true}
            fieldsName="PreviousButton"
            lang={lang}
            onClick={async () => {
              // Save without validation
              await dispatch(
                UpdateAC_NT_AS_AwardSource({ ...state.AwardSource })
              );
              await dispatch(
                UpdateAC_NT_CM_Commitment({ ...state.Commitment })
              );
              navigate(
                "/researcher/ScientificContributionSubmittedForTheAwardScreen"
              );
                
            }}
            disabled={false}
            title={"حفظ"}
          />
          {/* Save Only Button */}
          <div className={`SaveButtonMarks ${lang === "ar" ? "rtl" : "ltr"}`}>
            <ButtonAHSF
              type={"submitter"}
              fieldsName="SaveButton"
              lang={lang}
              text="حفظ"
              onClick={async () => {
                await dispatch(
                  UpdateAC_NT_AS_AwardSource({ ...state.AwardSource })
                );
                await dispatch(
                  UpdateAC_NT_CM_Commitment({ ...state.Commitment })
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title:
                    lang === "ar" ? "تم الحفظ بنجاح" : "Saved Successfully",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }}
              disabled={false}
              title={"حفظ"}
              show={true}
            />
          </div>

          {/* Apply Button */}
          <ButtonAHSF
            type={"submitter"}
            fieldsName="ApplyButton"
            lang={lang}
            onClick={SaveDataPage}
            disabled={isSubmitting}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      {/* Popup Validation View */}
      <PopupAHSF
        title={
          lang === "ar"
            ? "يرجى تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        }
        componentBody={
          <ValidationView
            ValidationAllPage={true}
            ValidationMainList={AttachmentsAnswerList}
          />
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={
          PopupComponentValidationViewStatus &&
          AttachmentsAnswerList?.length > 0
        }
        isPopupOpenFunction={closePopupComponentValidationViewStatus}
      />
    </>
  );
};

export default AttachmentsAndDeclaration;
